import CardBase from 'components/cards/CardBase';
import React from 'react';

function InfoCard({ children }) {
    return (
        <CardBase styles="border border-gray-200 max-w-sm">
            <div className="p-4">{children}</div>
        </CardBase>
    );
}

export default InfoCard;
